import { api, attachAuthOptions } from '../../utils/api';

const USER_NOTIFICATIONS_ENDPOINT = (userId: number) => `notifications/${userId}/set-read`;

export async function setNotificationsAsRead(userId: number) {
  return api.post(USER_NOTIFICATIONS_ENDPOINT(userId), {}, attachAuthOptions());
}
